import { graphql } from '@eluve/graphql.tada';

export const patientOptionFragment = graphql(`
  fragment PatientOption on Patients @_unmask {
    __typename
    id
    firstName
    lastName
    dateOfBirth
    sex
    external_patients_info {
      __typename
      id
      email
      externalPatientId
      workPhoneNumber
      cellPhoneNumber
      homePhoneNumber
    }
  }
`);

export const tenantPatientsFragment = graphql(
  `
    fragment TenantPatients on Tenants {
      __typename
      id
      patients {
        ...PatientOption
      }
    }
  `,
  [patientOptionFragment],
);

export const addNewPatientMutation = graphql(
  `
    mutation AddNewPatient($input: PatientsInsertInput!) {
      insertPatientsOne(object: $input) {
        ...PatientOption
      }
    }
  `,
  [patientOptionFragment],
);

export const searchPatientsQuery = graphql(
  `
    query searchPatients($query: String!, $tenantId: uuid!, $limit: Int) {
      searchPatients(
        args: { search_term: $query, _tenant_id: $tenantId, _limit: $limit }
        where: {
          deceasedAt: { _isNull: true }
          deactivatedAt: { _isNull: true }
        }
      ) {
        __typename
        id
        ...PatientOption
      }
    }
  `,
  [patientOptionFragment],
);
